module.exports = __webpack_public_path__ + "img/layout_bottom_2.c04b1b00.jpg";